module.exports = __webpack_public_path__ + "static/media/Wed 4.58ec24c3.jpg";